import React from 'react'

export const ErrorIcon = () => {
  return (
    <svg
      width="35"
      height="36"
      viewBox="0 0 35 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.041 22.3743H18.9577V25.291H16.041V22.3743ZM16.041 10.7077H18.9577V19.4577H16.041V10.7077ZM17.4848 3.41602C9.43476 3.41602 2.91602 9.94935 2.91602 17.9993C2.91602 26.0493 9.43476 32.5827 17.4848 32.5827C25.5493 32.5827 32.0827 26.0493 32.0827 17.9993C32.0827 9.94935 25.5493 3.41602 17.4848 3.41602ZM17.4993 29.666C11.0535 29.666 5.83268 24.4452 5.83268 17.9993C5.83268 11.5535 11.0535 6.33268 17.4993 6.33268C23.9452 6.33268 29.166 11.5535 29.166 17.9993C29.166 24.4452 23.9452 29.666 17.4993 29.666Z"
        fill="#DA0808"
      />
    </svg>
  )
}
